import Vue from 'vue'
import Vuex from 'vuex'
import tccc from './modules/tccc'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    tccc
  }
})

